/*
Polyfills
* Controling classes
* Transforming elements
* jQuery-compatible API
* no chaining or anything fancy (come on...)
*/

/* eslint-disable no-param-reassign */
const poly = (() => {
  function addClass(el, className) {
    if (!el) {
      return;
    }
    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ` ${className}`;
    }
  }

  function removeClass(el, className) {
    if (!el) {
      return;
    }
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + // eslint-disable-line prefer-template
      className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  function hasClass(el, className) {
    return el.classList.contains(className);
  }

  function toggleClass(el, className) {
    if (hasClass(el, className)) {
      removeClass(el, className);
    } else {
      addClass(el, className);
    }
  }

  function transform(el, transformVal) {
    el.style.webkitTransform = transformVal;
    el.style.MozTransform = transformVal;
    el.style.msTransform = transformVal;
    el.style.transform = transformVal;
  }

  function filterByClass(els, filterVal) {
    const className = filterVal.substr(1);
    const filterFn = (el) => {
      if (hasClass(el, className)) {
        return true;
      }
      return false;
    };
    return Array.prototype.filter.call(els, filterFn);
  }

  function index(el) {
    const nodeList = Array.prototype.slice.call(el.parentNode.children);
    return nodeList.indexOf(el);
  }

  function each(els, func) {
    [].forEach.call(els, (el, i) => {
      func(el, i);
    });
  }

  function triggerEvent(el, eventName) {
    let event; // The custom event that will be created

    if (document.createEvent) {
      event = document.createEvent('HTMLEvents');
      event.initEvent(eventName, true, true);
    } else {
      event = document.createEventObject();
      event.eventType = eventName;
    }
    event.eventName = eventName;
    if (document.createEvent) {
      el.dispatchEvent(event);
    } else {
      el.fireEvent(`on${event.eventType}`, event);
    }
  }

  function parent(el, className) {
    if (!el.parentElement) {
      return null;
    }
    if (el.parentElement && hasClass(el.parentElement, className)) {
      return el.parentElement;
    }
    return parent(el.parentElement, className);
  }

  function $(el) {
    return {
      addClass: className => addClass(el, className),
      each: func => each(el, func),
      hasClass: className => hasClass(el, className),
      index: () => index(el),
      toggleClass: className => toggleClass(el, className),
      transform: transformVal => transform(el, transformVal),
      removeClass: className => removeClass(el, className),
    };
  }

  return {
    addClass,
    hasClass,
    filterByClass,
    toggleClass,
    transform,
    index,
    removeClass,
    triggerEvent,
    parent,
    $,
  };
})();

export default poly;
